import styled from 'styled-components';

export const RescheduleWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: -50px;
`;
